import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useNewRelic } from '@e3dc-react/shell/Libs/observability-tool'
import React from 'react'
import { useUserSettings } from 'src/Hooks'
import { CustomLayout, exportAsCsv, ExportWrapper } from 'src/Libs/chart-kit'
import { Resolution } from 'src/Libs/chart-kit/shared/types'
import { useHistoryExportData } from 'src/Libs/system-data-handler'

interface Props {
  filename: string
  customLayout?: CustomLayout
  tooltip?: string
  dataQa?: string
}

/**
 * Component to export history data as CSV via button. Allows to choose resolution from a menu based on the current chart's view.
 */
const ExportHistoryData: React.FC<Props> = ({ filename, customLayout, tooltip, dataQa }) => {
  const { t } = useCustomTranslation()
  const { pageActions } = useNewRelic()
  const { userSettings, isUserSettingsLoading } = useUserSettings()
  const { getHistoryExportData, isFetching } = useHistoryExportData(customLayout)

  const handleExport = async (resolution: Resolution): Promise<void> => {
    if (isUserSettingsLoading) return
    pageActions.componentClicked({
      componentName: 'chart-csv-export-button-history-data',
      userId: userSettings.userid?.toString(),
    })
    const { csvData, csvHeaders } = await getHistoryExportData(resolution, t)
    const headerWithSanitizedSums = csvHeaders.map(header => ({
      key: header.key,
      label: header.label.replace(/Σ/g, t('common.sum')),
    }))
    exportAsCsv(filename, csvData, headerWithSanitizedSums)
  }

  return <ExportWrapper onExport={handleExport} dataQa={dataQa} isFetching={isFetching} tooltip={tooltip} />
}

export default ExportHistoryData
